import React from "react";
import {updateCorrectAnswers} from "../../utils/questionUpdate";
import classes from "../questions.module.css";
import TFQuestionOptionNew from "./TFQuestionOptionNew";
import {GRADE_SCHEMA} from "../../utils/constants";

export default function TFQuestionNew({
                                          gradeSchema=GRADE_SCHEMA.GRADED.key,
                                          setQuestions,
                                          questions,
                                          selectedQuestion,
                                      }) {
    const {optionsMap, serialNo, correctAnswers=""} = selectedQuestion;
    const indexToChange = serialNo - 1;


    return (

        <div className={classes.optionsContainer}>
            {optionsMap.map((option, index) => {
                return (
                    <TFQuestionOptionNew
                        key={index}
                        gradeSchema={gradeSchema}
                        option={option}
                        selectedQuestion={selectedQuestion}
                        correctAnswers={correctAnswers}
                        handleCorrectAnswerChange={(input) => {
                            setQuestions(
                                updateCorrectAnswers(input, indexToChange, questions)
                            );
                        }}
                    />
                );
            })}
        </div>
    );
}
